import { mergeObjectTypes } from '../cacheHelpers';

const ShipmentsTableFilterValue = {
  merge: mergeObjectTypes,
  keyFields: ['key']
};

export default ShipmentsTableFilterValue;
